
// todo: investigate usage and re-add for hpx
import 'semantic-ui-css/semantic.min.css'

// HPX has been using this font family setting from semantic ui
const SYSTEM_FONT = 'Lato,"Helvetica Neue",Arial,Helvetica,sans-serif;';

export const hpxConfig = (config) => {
  config.customer = 'hpx';
  config.root_font_size = '14px';
  //config.root_font_family = SYSTEM_FONT;
  config.cart_toolbar_bg_color = 'white';
  config.cart_toolbar_top = '3rem';
  config.cart_panel_header_font_color = '#101820';
  config.cart_panel_header_margin = '0.5rem 0rem 0rem 0rem !important';
  config.kiosk_bg_color = "#101820";
  config.kiosk_primary_button_background = '#3A8DDE';
  config.topbar_bg_color = '#101820';
  config.kiosk_form_button_bg_color = '#EBA900';
  config.kiosk_form_button_font_color = '#101820';
  config.kiosk_form_button_border_color = '#EBA900';
  config.kiosk_login_bg = '/img/hp_kiosk_login_bg.png';
  config.kiosk_form_bg_color = 'white';
  config.kiosk_form_border = '3px solid #EBA900';
  config.kiosk_form_border_color = '#EBA900';
  config.kiosk_form_header_font_color = '#101820';
  config.kiosk_form_message_font_color = '#101820';
  config.kiosk_form_label_font_color = '#101820';
  config.kiosk_form_access_code_input_bg_color = 'white';
  config.kiosk_form_access_code_input_border_color = '#101820';
  config.kiosk_form_access_code_input_font_color = '#101820';
  config.kiosk_topbar_logo = '/img/hp_logo_horizontal.png'
  config.kiosk_topbar_logo_german = '/img/hp_logo_horizontal_german.png'
  config.kiosk_topbar_logo_french = '/img/hp_logo_horizontal_french.png'
  config.pwa_checkmark_color = '#EBA900';
  config.pwa_pswipe_footer_logo = '/img/hp_logo_horizontal.png';
  config.pwa_pswipe_footer_logo_german = '/img/hp_logo_horizontal_german.png';
  config.pwa_pswipe_footer_logo_french = '/img/hp_logo_horizontal_french.png';
  config.pwa_navbar_desktop_brand_logo = '/img/hp_logo_horizontal.png';
  config.pwa_navbar_desktop_brand_logo_german = '/img/hp_logo_horizontal_german.png';
  config.pwa_navbar_desktop_brand_logo_french = '/img/hp_logo_horizontal_french.png';
  config.pwa_pswipe_store_link = 'https://shop.harrypotterexhibition.com/';
  config.pwa_galleryimage_bg = '#101820';
  config.pwa_login_sideheader_bg_color = '#000';
  config.pwa_login_logo = '/img/hp_logo_horizontal.png';
  config.pwa_login_logo_height = '6rem';
  config.pwa_login_mini_logo = '/img/hp_logo_flat.png';
  config.pwa_login_forgot_btn_bg_color = '#e2e7ff';
  config.pwa_login_forgot_btn_font_color = '#394AA7';
  config.pwa_selection_main_bg_color = '#EBA900';
  config.pwa_selection_main_font_color = '#101820';
  config.pwa_selection_second_bg_color = 'white';
  config.pwa_selection_second_font_color = '#101820';
  config.pwa_selection_font_color = '#EBA900';
  config.pwa_selection_bg_color = '#101820';
  config.pwa_navbar_bg_color = '#101820';
  config.pwa_navbar_border_color = '#EBA900'
  config.pwa_card_label_border_color = '#EBA900';
  config.pwa_story_title_bg_color = '#101820';
  config.pwa_story_title_font_color = '#EBA900';
  config.pwa_stories_bg = '#101820';
  config.pwa_home_bg_color = '#101820'
  config.pwa_card_label_bg_color = '#101820';
  config.pwa_galleryimage_font_color = '#EBA900';
  config.pwa_navbar_font_color = '#EBA900';
  config.pwa_navbar_hover_bg_color = '#EBA900';
  config.pwa_navbar_hover_font_color = '#101820';
  config.pwa_default_font_color = '#EBA900';
  config.pwa_default_bg_color = '#101820';
  config.pwa_default_button_bg_color = '#EBA900';
  config.pwa_default_button_font_color = '#101820';
  config.legal_notes = 'WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)';
  config.kiosk_logout_btn_bg = '#EBA900';
  config.kiosk_logout_btn_font_color = '#101820';
  config.kiosk_logout_btn_padding = '0rem 1rem';
  config.kiosk_logout_btn_border = '1px solid #EBA900';
  config.kiosk_toolbar_bg = '#101820';
  config.kiosk_toolbar_header_font_color = '#EBA900';
  config.kiosk_toolbar_header_padding = '0.5rem';
  config.kiosk_cart_count_font_color = '#3A8DDE';
  config.kiosk_cart_icon_margin_right = '';
  config.kiosk_select_all_font_color = '#EBA900';
  //config.kiosk_modal_header_font_color = '#EBA900';
  config.kiosk_modal_header_font_color = 'rgb(33, 37, 41)';
  //config.kiosk_modal_content_font_color = '#EBA900';
  config.kiosk_modal_content_font_color = 'rgb(33, 37, 41)';
  config.kiosk_modal_border_color = '#EBA900';
  config.kiosk_modal_button_action_bg_color = '#EBA900';
  config.kiosk_modal_button_action_font_color = '#101820';
  //config.kiosk_modal_bg_color = '#101820';
  config.kiosk_modal_bg_color = '#fff';
  config.sub_font = '"SofiaProMedium", sans-serif';
  config.main_font = '"Mason Sans OT Regular", sans-serif';
  config.kiosk_inactivity_timeout = 20;
  config.kiosk_auto_logout_countdown = 20;
  config.login_error = "No photos for this account.  Please scan a band that was used at the photo station"
  config.select_all_enabled = '#EBA900';
  config.select_all_disabled = 'rgb(148 148 148)';
}
